module.exports = __webpack_public_path__ + "static/brown.cf85e8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/brown.png
// module id = 2178
// module chunks = 61762850755587